module.exports = __webpack_public_path__ + "static/img/会展.43eb11f9.png";